import { LIS } from "shared/actions/constants";
import { PWAction } from "shared/utils/redux";

export type BlockMeta = {
  printingCassette?: boolean;
};

export type BlockMetaState = {
  [key: number]: BlockMeta;
};

const blockMetaReducer = (
  state: BlockMetaState = {},
  action: PWAction
): BlockMetaState => {
  switch (action.type) {
    case LIS.BLOCK.PRINT_CASSETTES.REQUEST:
      return action.args.requestBody.block_ids.reduce(
        (newState: BlockMetaState, block_id: number) => {
          return {
            ...newState,
            [block_id]: {
              ...(state[block_id] || {}),
              printingCassette: true,
            },
          };
        },
        state
      );
    case LIS.BLOCK.PRINT_CASSETTES.REQUEST_ERROR:
      return action.args.requestBody.block_ids.reduce(
        (newState: BlockMetaState, block_id: number) => {
          return {
            ...newState,
            [block_id]: {
              ...(state[block_id] || {}),
              printingCassette: false,
            },
          };
        },
        state
      );
    case LIS.BLOCK.PRINT_CASSETTES.ERROR:
    case LIS.BLOCK.PRINT_CASSETTES.SUCCESS:
      return action.payload.block_ids.reduce(
        (newState: BlockMetaState, block_id: number) => {
          return {
            ...newState,
            [block_id]: {
              ...(state[block_id] || {}),
              printingCassette: false,
            },
          };
        },
        state
      );
    case LIS.SPECIMEN.PRINT_PIECE_COUNT.SUCCESS:
    case LIS.SPECIMEN.PRINT.SUCCESS:
    case LIS.BLOCK.CREATE.SUCCESS:
      if (!action.payload?.response?._meta?.cassette_printing_task_id)
        return state;
      return (action.payload.response._meta.created?.blocks || [])
        .concat(action.payload.response._meta.updated?.blocks || [])
        .reduce((newState: BlockMetaState, block_id: number) => {
          return {
            ...newState,
            [block_id]: {
              ...(state[block_id] || {}),
              printingCassette: true,
            },
          };
        }, state);
    case LIS.BLOCK.DESTROY.SUCCESS:
      if (!action.payload?.response?._meta?.cassette_printing_task_id)
        return state;
      if (
        !action.payload.response?._meta?.created?.blocks &&
        !action.payload.response?._meta?.updated?.blocks
      )
        return state;
      return (action.payload.response?._meta?.created?.blocks || [])
        .concat(action.payload.response?._meta?.updated?.blocks)
        .reduce((newState: BlockMetaState, block_id: number) => {
          return {
            ...newState,
            [block_id]: {
              ...(state[block_id] || {}),
              printingCassette: true,
            },
          };
        }, state);
    default:
      return state;
  }
};

export default blockMetaReducer;
